<template>
  <div
    class="main-nav"
  >
    <ul
      ref="nav"
      class="nav g-nav"
    >
      <li
        v-for="(sideBar, index) in sideBarList"
        :key="index"
        :class="{
          nav_selected: $store.state.eventCurSideBar == index,
        }"
      >
        <a href="javascript:;" @touchstart="touchsideBar(index, sideBar.ptt, sideBar)">
          <span>
            <img :src=" $store.state.eventCurSideBar == index ? sideBar.curIcon: sideBar.icon" />
            <i>{{ sideBar.name }}</i>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getEnv } from '@tencent/slug-function';
const { isMSDK, isSlugSDK  } = getEnv();

export default {
  name: 'SideBar',
  props: {
    sideBarList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      state: false,
      isMSDK,
      isSlugSDK,
    };
  },
  computed: {
  },
  mounted() {
    // 防止第一次进入的页面不是第一个tab，根据参数控制高亮tab。
    if (this.$route.query.curBar) {
      this.$store.state.eventCurSideBar = this.$route.query.curBar;
    }
  },
  methods: {
    touchsideBar(index, ptt, sideBar) {
      this.$store.state.eventCurSideBar = index;
      if (this.$route.name === 'edition-vote') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        document.body.scrollTop = 0;
        document.querySelector('#app').scrollTop = 0;
      }
      if (ptt) {
        window.PTTRun && window.PTTSendReport({
          action: 'btn',
          hottag: `${ptt && ptt[0]}_${ptt && ptt[1]}_${ptt && ptt[2]}`,
          fortest4: ptt && ptt[3],
        });
      }

      this.$router.push({ name: this.sideBarList[index].targetTo });
    },
  },
};
</script>


